import { xGridDateSort, xGridNumberSort } from '@AMIEWEB/Common';
import { XGridDefaultColumn } from '@AMIEWEB/Common/XGrid/cells/XGridDefaults';
import Switch from '@mui/material/Switch';
import { FormControlLabel, FormGroup } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  selectDefaultModDetails,
  selectIsEditExistingMod,
  selectIsEditMod,
  selectIsGridModAltered,
  selectModSavedStatus,
} from 'store/redux-store/placement-mods/selectors';
export const defaultTimeOffColumn = {
  ...XGridDefaultColumn,
  flex: 0,
};
export const getAssignedTimeOffGridColumns = (t, isExpanded, updateAssignedField) => [
  {
    ...defaultTimeOffColumn,
    field: 'assigned',
    headerName: t('placement.placementMods.assigned'),
    width: 100,
    hide: false,
    renderCell: params => <AssignedCell cellParams={params} updateAssignedField={updateAssignedField} />,
  },
  {
    ...defaultTimeOffColumn,
    field: 'startDate',
    headerName: t('placement.placementMods.startDate'),
    width: 100,
    hide: false,
    type: 'Date',
    sortComparator: xGridDateSort,
  },
  {
    ...defaultTimeOffColumn,
    field: 'endDate',
    headerName: t('placement.placementMods.endDate'),
    width: 100,
    hide: false,
    sortComparator: xGridDateSort,
  },
  {
    ...defaultTimeOffColumn,
    headerName: t('placement.placementMods.days'),
    field: 'days',
    width: 80,
    hide: false,
    align: 'right',
    type: 'number',
    sortComparator: xGridNumberSort,
  },
  {
    ...defaultTimeOffColumn,
    headerName: t('placement.placementMods.hours'),
    field: 'hours',
    align: 'right',
    width: 80,
    hide: false,
    type: 'number',
    sortComparator: xGridNumberSort,
  },
  {
    ...defaultTimeOffColumn,
    headerName: t('placement.placementMods.cost'),
    field: 'cost',
    width: 87,
    hide: false,
    align: 'right',
  },
  {
    ...defaultTimeOffColumn,
    headerName: t('placement.placementMods.facilityApprovedBy'),
    field: 'facilityApprovedBy',
    width: 149,
    hide: false,
  },
  {
    ...defaultTimeOffColumn,
    headerName: t('placement.placementMods.timeOffPayerDescription'),
    field: 'timeOffPayerDescription',
    width: isExpanded ? 430 : 200,
    hide: false,
  },
];

export const AssignedCell = ({
  cellParams,
  updateAssignedField,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cellParams: any;
  updateAssignedField: Function;
}) => {
  const isModEdit = useSelector(selectIsEditMod);
  const isGridModAltered = useSelector(selectIsGridModAltered);
  const modSavedResponse = useSelector(selectModSavedStatus);
  const isEditExistingMod = useSelector(selectIsEditExistingMod);
  const { placementTimeOffList } = useSelector(selectDefaultModDetails);
  const [isAssinged, setIsAssigned] = useState<boolean>(
    findRow(placementTimeOffList, cellParams.row.placementTimeOffId)?.assigned,
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsAssigned(event.target.checked);
    if (isEditExistingMod) {
      return updateAssignedField(cellParams.row.placementTimeOffId, event.target.checked, modSavedResponse);
    } else {
      return updateAssignedField(cellParams.row.placementTimeOffId, event.target.checked);
    }
  };

  useEffect(() => {
    if (isGridModAltered === false) {
      setIsAssigned(findRow(placementTimeOffList, cellParams.row.placementTimeOffId)?.assigned);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGridModAltered, placementTimeOffList]);

  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Switch
            onChange={e => {
              handleChange(e);
            }}
            checked={isAssinged}
            disabled={!isModEdit}
          />
        }
        label={isAssinged ? 'Yes' : 'No'}
      />
    </FormGroup>
  );
};
//*Finds the row data for a particular rowId
const findRow = (rows, RowId) => {
  return rows?.find(row => row.placementTimeOffId === RowId);
};
